import { Routes, Route } from 'react-router-dom'
import { AuthService } from 'modules/auth/services/AuthService'
import React, { useEffect, useState } from 'react'
import {
  URL_APPLICATION,
  URL_APPLICATION_CLIENT_SHOW,
  URL_APPLICATION_NEW,
  URL_APPLICATION_SHOW,
  URL_APPLICATION_EDIT,
  URL_APPLICATION_SHOW2,
  URL_APPLICATIONS,
  URL_CHANGE_PASSWORD,
  URL_CLIENTS,
  URL_CLIENTS_ID,
  URL_CONTACT,
  URL_FAQ_CREATE,
  URL_FAQ_EDIT,
  URL_HELP,
  URL_HOME,
  URL_NEWCLIENT,
  URL_PROFILE_USER,
  URL_RECOVER_PASSWORD,
  URL_REGISTER,
  URL_USER,
  URL_USERS,
  URL_RESULTS,
  URL_PATIENTS,
  URL_PATIENT_REQUESTS,
  URL_APPLICATION_TEMPLATE,
  URL_APPLICATION_TEMPLATE_NEW,
  URL_CLIENTS_SUB,
  URL_CREATE_FORM,
} from './routes-constants'
import {
  TITLE_APPLICACIONSDETAIL,
  TITLE_APPLICAIONSNEW,
  TITLE_APPLICATION,
  TITLE_APPLICATIONSMANAGE,
  TITLE_CLIENTS,
  TITLE_CONTACT,
  TITLE_FAQS_CREATE,
  TITLE_HELP,
  TITLE_HOME,
  TITLE_NEWCLIENT,
  TITLE_PROFILE_USER,
  TITLE_USERS,
  TITLE_RESULTS,
  TITLE_RESULTS2,
  TITLE_APPLICACIONSDETAIL2,
  TITLE_PATIENTS,
  TITLE_PATIENT_REQUESTS,
  TITLE_CREATE_FORM,
} from './title-constants'
import {
  COLOR_APPLICATIONS,
  COLOR_CLIENTS,
  COLOR_HOME,
  COLOR_MATCHING,
  COLOR_PRIMARY,
} from './color-constants'
import { Register } from '../pages/login/Register'
import { LoggedUser } from '../modules/auth/models/LoggedUser'
import { getAuthContainer } from '../container/auth-modules'
import { AUTH_SERVICE_KEY } from '../modules/auth'
import { RecoverPassword } from '../pages/login/RecoverPassword'
import { ChangePassword } from '../pages/login/ChangePassword'
import { ClientForm, ClientTable, SubClientTable } from '../pages/clients'
import {
  ApplicationDetail,
  ApplicationForm,
  ApplicationTable,
  ClientApp,
  NewApp,
  ApplicationEdit,
  ApplicationShow,
  ApplicationTemplate,
} from '../pages/application'
import { UserProfile } from '../pages/users/UserProfile'
import { UserForm, UsersTable } from '../pages/users'
import { HomeTable } from '../pages/home'
import { FormFaq, HelpContact, HelpTable } from '../pages/help'
import { Permission } from '../common/enums/Permissions'
import { useTranslation } from 'react-i18next'
import { Results } from '../pages/results'
import { PatientsTable } from 'pages/patients'
import { RequestsTable } from 'pages/requests'
import { ApplicationTemplateNew } from 'pages/application'
import { SubClinicsTable } from 'features/clients'
import { CreateFomr } from 'pages/form'

export type RouteProps = {
  title?: string
  subtitle?: string
  color?: string
  id?: string
  origin?: string
}

const authService = getAuthContainer().get<AuthService>(AUTH_SERVICE_KEY)

export const AppRouter: React.FC = () => {
  const { t } = useTranslation()
  const [user, setUser] = useState<LoggedUser>(authService.get())

  useEffect(() => {
    authService.getObservable().subscribe((u: LoggedUser) => setUser(u))
  }, [])

  const publicRoutes = (
    <>
      <Route path={URL_REGISTER} element={<Register />} />
      <Route path={URL_RECOVER_PASSWORD} element={<RecoverPassword />} />
      <Route path={URL_CHANGE_PASSWORD} element={<ChangePassword />} />
    </>
  )

  const generalRoutes = (
    <>
      <Route
        path={URL_APPLICATION_TEMPLATE_NEW}
        element={
          <ApplicationTemplateNew color={COLOR_APPLICATIONS} title={t('request')} />
        }
      />
      <Route
        path={URL_APPLICATION_TEMPLATE}
        element={
          <ApplicationTemplate color={COLOR_APPLICATIONS} title={t('request')} />
        }
      />
      <Route
        path={URL_PATIENT_REQUESTS}
        element={
          <RequestsTable color={COLOR_APPLICATIONS} title={t(TITLE_PATIENT_REQUESTS)} origin="patients_request" />
        }
      />
      <Route
        path={URL_PATIENTS}
        element={<PatientsTable color={COLOR_APPLICATIONS} title={t(TITLE_PATIENTS)} />}
      />
      {authService.userCan(Permission.editTestTypes) && (
        <Route
          path={URL_HOME}
          element={
            <HomeTable color={COLOR_HOME} title={user.language === 'es' ? t(TITLE_HOME) : 'Home'} />
          }
        />
      )}
      {authService.userCan(Permission.viewUsers) && (
        <Route
          path={URL_USERS}
          element={
            <UsersTable color={COLOR_HOME} title={user.language === 'es' ? t(TITLE_USERS) : 'Users'} />
          }
        />
      )}
      {authService.userCan(Permission.editUsers) && (
        <Route
          path={URL_USER}
          element={
            <UserForm color={COLOR_HOME} title={user.language === 'es' ? t(TITLE_USERS) : ' Users'} />
          }
        />
      )}
      {authService.userCan(Permission.viewClients) && (
        <Route
          path={URL_CLIENTS}
          element={
            <ClientTable color={COLOR_CLIENTS} title={user.language === 'es' ? t(TITLE_CLIENTS) : 'Clients'} />
          }
        />
      )}

      {authService.userCan(Permission.viewClients) && (
        <Route
          path={URL_CLIENTS_SUB}
          element={
            <SubClientTable color={COLOR_CLIENTS} title={user.language === 'es' ? t(TITLE_CLIENTS) : 'Clients Sub'} />
          }
        />
      )}
      {authService.userCan(Permission.editClinics) && (
        <Route
          path={URL_NEWCLIENT}
          element={
            <ClientForm color={COLOR_CLIENTS} title={user.language === 'es' ? t(TITLE_NEWCLIENT) : 'New client'} />
          }
        />
      )}
      {authService.userCan(Permission.editClinics) && (
        <Route
          path={URL_CLIENTS_ID}
          element={
            <ClientForm color={COLOR_CLIENTS} title={user.language === 'es' ? t(TITLE_NEWCLIENT) : 'New client'} />
          }
        />
      )}

      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATIONS}
          element={
            <ApplicationTable color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICATIONSMANAGE) : 'Requests'} />
          }
        />
      )}
      {authService.userCan(Permission.editPatients) && (
        <Route
          path={URL_APPLICATION}
          element={
            <ApplicationForm color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICATION) : 'Request'} />
          }
        />
      )}
      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATION_SHOW}
          element={
            <ApplicationDetail color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICACIONSDETAIL) : 'Request /Details'} />
          }
        />
      )}
      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATION_EDIT}
          element={
            <ApplicationEdit color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICACIONSDETAIL) : 'Request /Details'} />
          }
        />
      )}
      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATION_SHOW2}
          element={
            <ApplicationShow color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICACIONSDETAIL2) : 'Request /Details'} />
          }
        />
      )}
      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATION_CLIENT_SHOW}
          element={
            <ClientApp color={COLOR_APPLICATIONS} title={t('clients') + ' / ' + t('requests')} />
          }
        />
      )}
      {authService.userCan(Permission.viewPatients) && (
        <Route
          path={URL_APPLICATION_NEW}
          element={
            <NewApp color={COLOR_APPLICATIONS} title={user.language === 'es' ? t(TITLE_APPLICAIONSNEW) : 'New Request'} />
          }
        />
      )}

      {authService.userCan(Permission.viewFaqs) && (
        <Route
          path={URL_HELP}
          element={
            <HelpTable color={COLOR_MATCHING} title={user.language === 'es' ? t(TITLE_HELP) : 'Help'} />
          }
        />
      )}

      {authService.userCan(Permission.viewFaqs) && (
        <Route
          path={URL_CONTACT}
          element={
            <HelpContact color={COLOR_MATCHING} title={user.language === 'es' ? t(TITLE_CONTACT) : 'Contact'} />
          }
        />
      )}

      {authService.userCan(Permission.editFaqs || Permission.createFaqs) && (
        <Route
          path={URL_FAQ_CREATE}
          element={
            <FormFaq color={COLOR_MATCHING} title={user.language === 'es' ? t(TITLE_FAQS_CREATE) : 'Create a FAQ'} />
          }
        />
      )}
      {authService.userCan(Permission.editFaqs || Permission.createFaqs) && (
        <Route
          path={URL_FAQ_EDIT}
          element={
            <FormFaq color={COLOR_MATCHING} title={user.language === 'es' ? t(TITLE_FAQS_CREATE) : 'Create a FAQ'} />
          }
        />
      )}

      {authService.userCan(Permission.seeResults) && (
        <Route
          path={URL_RESULTS}
          element={<Results color={COLOR_MATCHING} title={authService.userCan(Permission.addResults) ? t(TITLE_RESULTS2) : t(TITLE_RESULTS)} />}
        />
      )}

      {authService.userCan(Permission.seeResults) && (
        <Route
          path={URL_CREATE_FORM}
          element={<CreateFomr color={COLOR_MATCHING} title={t(TITLE_CREATE_FORM)} />}
        />
      )}

      <Route
        path={URL_PROFILE_USER}
        element={
          <UserProfile color={COLOR_PRIMARY} title={user.language === 'es' ? t(TITLE_PROFILE_USER) : 'Profile'} />
        }
      />
    </>
  )

  return <Routes>{user.id ? generalRoutes : publicRoutes}</Routes>
}
